<template>
  <div class="wh-block wh-block--reaction" v-if="reaction">
    <div class="reaction">
      <!--<video loop muted preload="auto" autoplay>-->
      <video disableRemotePlayback preload="auto" autoplay @ended="stopReaction" @click="breakReaction">
        <source type="video/mp4" :src="'/storage/app/media/' + video" id="mp4">
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "reaction",
  data() {
    return {
      reaction: false
    }
  },
  watch: {
    show_reaction: 'checkReaction'
  },
  props: {
    video: '',
    show_reaction: {
      default: false
    }
  },
  methods: {
    checkReaction() {
      if (this.show_reaction) {
        this.reaction = true;
        this.$emit('onStartReaction');
      }
    },
    stopReaction() {
      this.stopVideo();
      this.$emit('onVideoEnd');
    },
    breakReaction() {
      this.stopVideo();
    },
    stopVideo() {
      this.$emit('onStopReaction');
      this.reaction = false;
    }
  }
}
</script>